// src/js/components/fam-doc-card.js

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-doc-card]").forEach((wrap) => {
    const card = wrap.querySelector(".js-doc-card");
    if (!card) return;

    const titleEl = card.querySelector(".js-doc-title");
    const textEl = card.querySelector(".js-doc-text");
    const iconWrap = card.querySelector(".js-doc-icon-wrap");
    const icon = card.querySelector(".js-doc-icon");
    const linkEl = card.querySelector(".js-doc-link");
    const disabledEl = card.querySelector(".js-doc-disabled");

    // Recoger textos
    const title = wrap.dataset.title || "";
    const text = wrap.dataset.text || "";
    const theme = wrap.dataset.theme || "primary"; // primary, accent, gray
    
    // Obtener enlace nativo para compatibilidad con Parcel
    const linkAnchor = wrap.querySelector("a.js-doc-asset");
    const link = linkAnchor ? linkAnchor.getAttribute("href") : (wrap.dataset.link || "");

    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;

    // Aplicar estilos del tema (Primary por defecto)
    if (theme === "primary") {
      card.classList.add("border-gray-100");
      iconWrap.classList.add("bg-primary/10");
      icon.classList.add("text-primary");
      titleEl.classList.add("text-tinta");
      textEl.classList.add("text-text-main/70");
      linkEl.classList.add("bg-text-main", "hover:bg-primary");
    } else if (theme === "accent") {
      card.classList.add("border-gray-100");
      iconWrap.classList.add("bg-accent/10");
      icon.classList.add("text-accent");
      titleEl.classList.add("text-tinta");
      textEl.classList.add("text-text-main/70");
      linkEl.classList.add("bg-text-main", "hover:bg-accent");
    } else if (theme === "gray") {
      card.classList.add("border-dashed", "border-gray-300");
      iconWrap.classList.add("bg-gray-200");
      icon.classList.add("text-gray-500");
      titleEl.classList.add("text-gray-600");
      textEl.classList.add("text-text-main/50", "italic");
    }

    // Gestionar renderizado condicional de botón
    if (link && link !== "#" && theme !== "gray") {
      linkEl.href = link;
      linkEl.style.display = "inline-flex";
      disabledEl.style.display = "none";
    } else {
      linkEl.style.display = "none";
      disabledEl.style.display = "inline-flex";
    }
  });
});
